export default __webpack_public_path__ + "static/media/java.8cb1fd4a.svg";